import { PurchaseModeV2 } from "@wix/package-picker-common";
import { MoneyBackGuarantee as MoneyBackGuaranteeUi } from "@wix/package-picker-components";
import * as React from "react";
import { useQueriesHandler, useQueryParams } from "../../../hooks";
import { useSiteGuid } from "../../../hooks/useSiteGuid";
import { PackagePickerApiClient, usePackagePickerType } from "../../../providers";
import { AUTONOMOUS_COMPONENT_NAMES } from "../../../types";
const COMPONENT_NAME = AUTONOMOUS_COMPONENT_NAMES.MONEY_BACK_GUARANTEE;
export const MoneyBackGuarantee = _ref => {
  var _offeringQuery$data;
  let {
    onInit,
    onLoad,
    onError
  } = _ref;
  const {
    packagePickerType
  } = usePackagePickerType();
  const siteGuid = useSiteGuid();
  const {
    isChangePlan
  } = useQueryParams();
  const {
    useOffering
  } = PackagePickerApiClient.hooks;
  const offeringQuery = useOffering({
    packagePickerType,
    isChangePlan,
    siteGuid
  });
  const purchaseMode = (_offeringQuery$data = offeringQuery.data) == null ? void 0 : _offeringQuery$data.purchaseMode;
  const {
    isSuccess
  } = useQueriesHandler({
    callbacks: {
      onLoad,
      onError,
      onInit
    },
    queries: {
      offeringQuery
    },
    componentName: COMPONENT_NAME
  });
  if (!isSuccess || !offeringQuery.data || isChangePlan) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MoneyBackGuaranteeUi, {
    packagePickerType: packagePickerType,
    isSecondUpgrade: purchaseMode === PurchaseModeV2.SecondUpgrade
  });
};
//# sourceMappingURL=MoneyBackGuarantee.js.map